import { type IDetailItemDicInfo } from '@interface/IDetail';
import classNames from 'classnames';
import { ProbabilityBtn } from './ProbabilityBtn';

export const RandomOptions = ({ iteminfo }: { iteminfo: IDetailItemDicInfo }) => {
    if (!iteminfo.randomOptions?.length) return null;
    return (
        <ul
            className={classNames({
                topborder:
                    iteminfo.additional?.count > 0 ||
                    iteminfo.options?.length > 0 ||
                    iteminfo.subOptions.fixes?.length > 0 ||
                    iteminfo.subOptions.randoms?.length > 0,
            })}
        >
            {iteminfo.randomOptions.map((option, idx) => (
                <li key={`random-option-${idx}`}>
                    <div className="value">
                        {option.name} {option.origin}개
                    </div>
                    <ProbabilityBtn />
                </li>
            ))}
        </ul>
    );
};
